<template>
  <div class="box">
    <van-search
      v-model="keyWord"
      shape="round"
      placeholder="搜索"
      color= '#000'
      @input="voteSearch"
    />
    <div class="dynamic_list">
      <div v-if="list.length === 0">暂无数据</div>
      <DYNAMICCRADVUE v-else style="margin-bottom: 20px;" @click.native="goDynamic(item)" v-for="(item,index) in list.slice(0,9)" :index="index" v-bind="item" :key='item.id' />
    </div>
  </div>
</template>

<script>
import DYNAMICCRADVUE from './components/dynamicCrad.vue'
import { getTopicollections, getTopicBYstring } from '../../../api/api'
export default {
  components: {
    DYNAMICCRADVUE
  },
  data () {
    return {
      keyWord: '',
      list: []
    }
  },
  mounted () {
    this.getAllTopic()
  },
  methods: {
    goDynamic (tag) {
      this.$router.push({
        name: 'FilterFind',
        params: {
          id: tag.id,
          title: tag.name || tag.title
        }
      })
    },
    voteSearch () {
      this.list = []
      if (this.keyWord === '') {
        this.getAllTopic()
      } else {
        this.onLoad()
      }
    },
    async onLoad () {
      try {
        const result = await getTopicBYstring(this.keyWord)
        this.list = result.detail
        if (this.list[0].id === 0) {
          this.list.shift()
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      }
    },
    async getAllTopic () {
      try {
        const result = await getTopicollections()
        if (result.code === 200) {
          this.list = result.detail
        }
      } catch (error) {
        /* eslint-disable */
        console.log(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100vw;
  .dynamic_list {
    width: 90%;
    margin: 10px auto 0;
  }
}

</style>
